import actions from "./actions";

const { FETCH_MAIN_CLUB, FETCH_MAIN_CLUBS, RESET_MAIN_CLUB } = actions;

const initState = {
    mainClubs: {
        page: 0,
        perPage: 10,
        data: [],
        total: 0
    },
    mainClub: {
        _id: null,
        name: "",
        code: "",
        description: "",
        photo: null,
        status: "active",
        session: null,
        presidents: [],   // Array of student snapshots [{ _id, firstName, lastName, studentId, photo }]
        secretaries: [],  // Array of student snapshots [{ _id, firstName, lastName, studentId, photo }]
        teachers: []      // Array of teacher/user snapshots [{ _id, firstName, lastName, photo, phone, designation }]
    }
};

const MainClubReducer = (state = initState, action) => {
    const { type, data } = action;
    switch (type) {
        case FETCH_MAIN_CLUBS:
            return {
                ...state,
                mainClubs: {
                    ...initState.mainClubs,
                    ...data,
                    data: Array.isArray(data?.data) ? data.data : []
                }
            };

        case RESET_MAIN_CLUB:
            return {
                ...state,
                mainClub: { ...initState.mainClub }
            };

        case FETCH_MAIN_CLUB:
            return {
                ...state,
                mainClub: {
                    ...initState.mainClub,
                    ...data,
                    // Ensure nested snapshots are safely extracted as arrays
                    presidents: Array.isArray(data?.presidents) ? data.presidents : [],
                    secretaries: Array.isArray(data?.secretaries) ? data.secretaries : [],
                    teachers: Array.isArray(data?.teachers) ? data.teachers : []
                }
            };

        default:
            return state;
    }
};

export default MainClubReducer;